import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  commonZH, commonEN, commonJA,
  staticContentZH, staticContentEN, staticContentJA,
  modalZH, modalEN, modalJA,
  dataIOZH, dataIOEN, dataIOJA,
  resourceLimitZH, resourceLimitEN, resourceLimitJA
} from '@redpanda/common-locales';
import { deepMerge, mergeTranslations, createI18nInitConfig } from '@redpanda/utils';

// 本地翻譯檔案
import translationZH from './locales/zh/translation.json';
import translationEN from './locales/en/translation.json';
import translationJA from './locales/ja/translation.json';
import manualZH from './locales/zh/manual.json';
import manualEN from './locales/en/manual.json';
import manualJA from './locales/ja/manual.json';
import staticContentLocalZH from './locales/zh/static-content.json';
import staticContentLocalEN from './locales/en/static-content.json';
import staticContentLocalJA from './locales/ja/static-content.json';

const resources = {
  zh: {
    translation: mergeTranslations(commonZH, translationZH),
    manual: manualZH,
    staticContent: deepMerge(staticContentZH, staticContentLocalZH),
    modal: modalZH,
    dataIO: dataIOZH,
    resourceLimit: resourceLimitZH,
  },
  en: {
    translation: mergeTranslations(commonEN, translationEN),
    manual: manualEN,
    staticContent: deepMerge(staticContentEN, staticContentLocalEN),
    modal: modalEN,
    dataIO: dataIOEN,
    resourceLimit: resourceLimitEN,
  },
  ja: {
    translation: mergeTranslations(commonJA, translationJA),
    manual: manualJA,
    staticContent: deepMerge(staticContentJA, staticContentLocalJA),
    modal: modalJA,
    dataIO: dataIOJA,
    resourceLimit: resourceLimitJA,
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ...createI18nInitConfig({ resources }),
    react: {
      useSuspense: false
    }
  });

export default i18n;
